import {
  EXECUTE_SURGE_COMPAIGN,
  EXECUTE_SURGE_COMPAIGN_SUCCESS,
  EXECUTE_SURGE_COMPAIGN_ERROR,
  EXECUTE_SURGE_COMPAIGN_EMPTY,
} from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ExecuteSurgeCompaign = (state = initialState, action) => {
  switch (action.type) {
    case EXECUTE_SURGE_COMPAIGN:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case EXECUTE_SURGE_COMPAIGN_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case EXECUTE_SURGE_COMPAIGN_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case EXECUTE_SURGE_COMPAIGN_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ExecuteSurgeCompaign;
